const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const Sync = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SYNC_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'SYNC_ERROR':
            return { loading: false, error: true, data: action.payload };
        case 'SYNC_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'SYNC_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default Sync